// const vue = require('vue');
const axiosBase = require('axios').default;
import Qs from 'qs'

// ========= [NEW] 두 개의 axios 인스턴스 =========

// 1) 기존
const legacy = axiosBase.create({
	// baseURL 필요하면 넣어도 됨
	timeout: 15000,
});

// 2) JWT 전용: 쿠키 + CSRF + 401-refresh
const jwtApi = axiosBase.create({
	withCredentials: true, // 쿠키 전송 필수
	timeout: 15000,
});
jwtApi.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
jwtApi.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
jwtApi.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

function getCookie(name) {
	return document.cookie
		.split('; ')
		.find((v) => v.startsWith(name + '='))
		?.split('=')[1];
}

function isFD(v) {
	return typeof FormData !== 'undefined' && v instanceof FormData;
}

// 요청: 변경 메서드에만 CSRF 헤더 자동 첨부
jwtApi.interceptors.request.use((cfg) => {
	const m = (cfg.method || 'get').toLowerCase();
	if (['post', 'put', 'patch', 'delete'].includes(m)) {
		const csrf = getCookie('XSRF-TOKEN');
		if (csrf) cfg.headers['X-XSRF-TOKEN'] = decodeURIComponent(csrf);

		if (isFD(cfg.data)) {
			// 기본 defaults의 x-www-form-urlencoded를 덮지 않도록 제거
			if (cfg.headers) {
				delete cfg.headers['Content-Type'];
				delete cfg.headers['content-type'];
			}
		}
	}
	return cfg;
});

// 응답: 401이면 /auth/refresh 1회 → 원요청 재시도
let isRefreshing = false;
let waitQueue = [];
let onUnauthorized = null; // (선택) 최종 401 실패시 라우팅 등

function flushQueue(ok) {
	waitQueue.forEach((cb) => { try { cb(ok) } catch (_) { /* ignore */ } });
	waitQueue = [];
}

jwtApi.interceptors.response.use(
	(res) => res,
	async (error) => {
		const { config, response } = error || {};
		if (!response) return Promise.reject(error);
		const is401 = response.status === 401;
		const isRefresh = (config?.url || '').includes('/auth/refresh');
		if (!is401 || isRefresh || config._retry) return Promise.reject(error);

		if (isRefreshing) {
			return new Promise((resolve, reject) => {
				waitQueue.push((ok) => ok ? resolve(jwtApi(config)) : reject(error));
			});
		}

		isRefreshing = true;
		try {
			await jwtApi.post('/auth/refresh');
			config._retry = true;
			flushQueue(true);
			return jwtApi(config);
		} catch (e) {
			flushQueue(false);
			if (typeof onUnauthorized === 'function') {
				try { onUnauthorized(); } catch (_) { /* ignore */ }
			}
			throw e;
		} finally {
			isRefreshing = false;
		}
	}
);

function pickClient(url) {
	// JWT 구간: /api/jwt/** 로 약속
	return (typeof url === 'string' && url.startsWith('/api/jwt/')) ? jwtApi : legacy;
}


const AxiosCaller = {

	// (선택) 401 최종 실패시 동작 주입: 라우터로 로그인 보내기 등
	setUnauthorizedHandler(fn) { onUnauthorized = fn; },

	sendSlim(_data) {
		_data = (_data == null) ? {} : _data;
		_data.userId = _data.LOGIN_ID

		delete _data.status
		delete _data.createDate
		delete _data.updateDate
		delete _data.createUserId
		delete _data.updateUserId
		delete _data.startSearchDate
		delete _data.endSearchDate

		delete _data.commentList
		delete _data.attachList
		delete _data.thumbFile
		delete _data.cateVO
		delete _data.codeVO

		delete _data.startDate
		delete _data.endDate

		delete _data.coInfoVO
	},

	returnSlim(_data) {
		_data = (_data == null) ? {} : _data;
		delete _data.userId
		delete _data.LOGIN_ID
		delete _data.LOGIN_NICK
		delete _data.LOGIN_DOMAIN
		delete _data.createUserId
		delete _data.updateuserId
		delete _data.updateDate
	},

	logError(_res) {
		if (_res?.data?.status === "error") {
			console.log(_res.data.msg)
		}
	},

	setSessionParams(_data, $this) {
		// 레거시는 기존대로 쓰고, JWT 구간은 서버가 무시해도 무방
		_data = (_data == null) ? {} : _data;
		_data.JSESSIONID = $this?.JSESSIONID?.();
		_data.isLogin = $this?.isLogin?.()
		_data.LOGIN_DOMAIN = _data.LOGIN_DOMAIN ? _data.LOGIN_DOMAIN : $this?.webUtils?.getSubdomain();
		_data.coCode = _data.coCode ? _data.coCode : _data.LOGIN_DOMAIN;

		if ($this?.isLogin?.()) {
			_data.LOGIN_ID = $this.getSessionProc().coEmailId;
			_data.userId = _data.LOGIN_ID;
			_data.LOGIN_NICK = $this.getSessionProc().nickName;
		} else {
			_data.LOGIN_ID = $this?.getVueSessionID?.();
			_data.userId = _data.LOGIN_ID;
			_data.LOGIN_NICK = _data.LOGIN_ID;
		}
	},

	get($this, _url, _data, _callback, _catch = null) {
		$this?.doSyncdate?.()
		this.setSessionParams(_data, $this);
		this.sendSlim(_data);

		const client = pickClient(_url);
		client.get(_url, { params: _data })
			.then((res) => {
				this.returnSlim(res.data)
				this.returnSlim(_data)
				this.logError(res);
				_callback(res)
			})
			.catch((reason) => {
				console.log(reason)
				if (_catch) _catch(reason);
			});
	},

	put($this, _url, _data, _callback, _catch = null) {
		this.process($this, "put", _url, _data, _callback, _catch)
	},

	post($this, _url, _data, _callback, _catch = null) {
		this.process($this, "post", _url, _data, _callback, _catch)
	},

	/** POST with JSON body (Content-Type: application/json). Use when backend expects @RequestBody Map. */
	postJson($this, _url, _data, _callback, _catch = null) {
		$this?.doSyncdate?.()
		const client = pickClient(_url)
		if (!isFD(_data)) {
			this.setSessionParams(_data, $this)
			this.sendSlim(_data)
		}
		client({
			method: 'post',
			url: _url,
			data: _data,
			maxContentLength: Infinity,
			maxBodyLength: Infinity,
			headers: { 'Content-Type': 'application/json' },
			transformRequest: [(data) => (typeof data === 'object' && !isFD(data) ? JSON.stringify(data) : data)]
		})
			.then((res) => {
				this.returnSlim(res.data)
				if (typeof _data === 'object' && !isFD(_data)) this.returnSlim(_data)
				this.logError(res)
				_callback(res)
			})
			.catch((reason) => {
				console.log(reason)
				if (_catch) _catch(reason)
			})
	},

	patch($this, _url, _data, _callback, _catch = null) {
		this.process($this, "patch", _url, _data, _callback, _catch)
	},

	delete($this, _url, _data, _callback, _catch = null) {
		$this?.doSyncdate?.()
		this.setSessionParams(_data, $this);
		this.sendSlim(_data);

		const client = pickClient(_url);
		client.delete(_url, { params: _data })
			.then((res) => {
				this.returnSlim(res.data)
				this.returnSlim(_data)
				this.logError(res);
				_callback(res)
			})
			.catch((reason) => {
				console.log(reason)
				if (_catch) _catch(reason);
			});
	},

	process($this, _methods, _url, _data, _callback, _catch = null) {
		$this?.doSyncdate?.()

		const client = pickClient(_url);
		const fdMode = isFD(_data);

		if (fdMode) {
			// FormData 전송 시: 세션 파라미터도 유지하려면 append
			const extra = {};
			this.setSessionParams(extra, $this);
			this.sendSlim(extra); // 불필요 필드 제거
			Object.entries(extra).forEach(([k, v]) => {
				if (v != null) _data.append(k, v);
			});
			// FormData에는 기존 sendSlim/object 변형 금지 (이미 append로 끝)
		} else {
			// 기존 동작 (object 전송)
			this.setSessionParams(_data, $this);
			this.sendSlim(_data);
		}

		client({
			method: _methods,
			url: _url,
			data: _data,
			maxContentLength: Infinity,
			maxBodyLength: Infinity,

			// --- [MOD] FormData면 절대 stringify 금지 ---
			transformRequest: [function (data, headers) {
				return fdMode
					? data // 그대로 전송 → 브라우저가 boundary 포함해 multipart 설정
					: Qs.stringify(data, { arrayFormat: 'repeat' });
			}],

			// --- [MOD] FormData면 헤더 비워서 defaults 덮어쓰기 방지 (인터셉터에서도 제거) ---
			headers: fdMode ? {} : undefined,
		})
			.then((res) => {
				this.returnSlim(res.data);
				if (!fdMode) this.returnSlim(_data);
				this.logError(res);
				_callback(res);
			})
			.catch((reason) => {
				console.log(reason);
				if (_catch) _catch(reason);
			});
	}
}

export default AxiosCaller;
